import { Injectable } from "@angular/core";
import { CanActivate, CanDeactivate,  RouterStateSnapshot,ActivatedRouteSnapshot, UrlTree, Router, ActivatedRoute} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../Services/AuthService/auth-service.service";
import { ActivateAgentComponent } from "./activate-Account/activate-account.component";

@Injectable()
export class AuthGard  implements CanActivate{
    constructor(private router: Router, private _authService: AuthService, private activatedRoute: ActivatedRoute) {}
    
    canActivate(){
        // Check to see if a user has a valid token
        if (this._authService.isAuthenticated()) {
            // If they do, return true and allow the user to load app
            return true;
        }
        // If not, they redirect them to the login page
        this.router.navigateByUrl('/sign-in');
        return false;
    }
}


export class AccountNotCreatedAuthGard  implements CanDeactivate<ActivateAgentComponent>{
    canDeactivate(component: ActivateAgentComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return component.isAccountcreated  || window.confirm("Are you sure?")
    }
}

